import styled from "styled-components";
import { Button as DefaultButton } from "../../button/button";

export const Container = styled.div`
  background-color: #dcfff8;
  padding: 80px 0px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;
  }
`;

export const ContainerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
`;

export const CampaignContainer = styled(Container)`
  background-color: rgb(8, 79, 67);
  color: #fff;
`;

export const CampaignRelativeWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1154px;
  width: 100%;
`;

export const CampaignWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
`;

export const CampaignFormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
  z-index: 1;

  label {
    color: #fff;
  }
`;

export const CampaignImageColumn = styled.div<{ $src: string }>`
  background-image: url(${({ $src }) => $src});
  background-size: contain;
  background-position: right bottom;
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
  bottom: -80px;
  width: 50%;
  height: calc(100% + 80px);

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Title = styled.h3`
  color: #00a687;
  text-align: center;

  em,
  i {
    font-style: italic;
  }

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 36.77px;
  }
`;

export const CampaignTitle = styled(Title)`
  color: #fff;
  max-width: 50%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const CampaignCpfHint = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: -8px;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;

  @media (max-width: 768px) {
    gap: 0px;
  }
`;

export const Button = styled(DefaultButton)`
  font-family: Ubuntu;
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  margin-top: 16px;
  text-align: center;
  width: 100%;
`;

export const SuccessMessage = styled.p`
  color: #00a687;
  font-size: 16px;
  font-weight: 600;
  margin-top: 8px;
  text-align: center;
`;

export const ErrorMessage = styled.p`
  color: #cc0000;
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
`;

export const CpfHint = styled.p`
  color: #666666;
  font-size: 12px;
  margin-top: -8px;
  text-align: center;
`;
